import React, { useCallback, useState } from 'react'
import { Box, Button, Card, CardContent, Checkbox, Divider, FormControl, FormControlLabel, IconButton, InputAdornment, InputLabel, OutlinedInput, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useNavigate } from 'react-router';
import { useAuth } from '../../utils/auth';
import ReadylyHeader from '../../components/ReadylyHeader/ReadylyHeader.jsx';
import logo from '../../images/readyly_logo.png'
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import LoginOutlinedIcon from '@mui/icons-material/LoginOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PinOutlinedIcon from '@mui/icons-material/PinOutlined';
import SaveAsIcon from '@mui/icons-material/SaveAs';

const ForgotPassword = () => {
    // Constants:
    const navigate = useNavigate();
    const auth = useAuth();

    // State:
    const [code, setCode] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    // Functions:
    const sendcode = useCallback((event) => {
        event.preventDefault();
        auth.sendCode(email);
    }, [auth, email]);

    const changepassword = useCallback(
        async (event) => {
            event.preventDefault();
            try {
                await auth.validatePassword(email, code, password);
            } catch (error) {
                console.error(error);
            }
        },
        [auth, code, email, password]
    );

    return (
        <div>
            <ReadylyHeader />
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: "100%" }}>
                <Card sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: isMobile ? "90%" : "30%", marginTop: "10%", padding: "15px", borderRadius: "30px" }}>
                    <img src={logo} alt="Readyly Logo" width="15%" height="15%" />
                    <CardContent>
                        <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }}>
                            Powering speed and accuracy
                        </Typography>
                    </CardContent>
                    <Divider variant="fullWidth" sx={{ color: "text.primary" }} />
                    <form onSubmit={sendcode} style={{ width: "100%" }}>
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, marginBottom: 2, width: "100%", alignItems: "center", justifyContent: "center" }} >
                            <FormControl required fullWidth variant="outlined" size="small" sx={{ textTransform: "none" }}>
                                <InputLabel htmlFor="outlined-adornment-password">Email</InputLabel>
                                <OutlinedInput
                                    type="email"
                                    value={email}
                                    fullWidth
                                    sx={{ textTransform: "none" }}
                                    onChange={(event) => setEmail(event.target.value.trim())}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton edge="end" >
                                                <EmailOutlinedIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    label="Email"
                                />
                            </FormControl>
                            <Button type="submit" disabled={email.trim() === ""} variant="contained" sx={{ textTransform: "none", maxWidth: "50%" }} startIcon={<PinOutlinedIcon />} >Send OTP</Button>
                        </Box>
                    </form>
                    <form onSubmit={changepassword} style={{ width: "100%" }}>
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, width: "100%", alignItems: "center", justifyContent: "center" }} >
                            <FormControl required fullWidth variant="outlined" size="small" sx={{ textTransform: "none" }}>
                                <InputLabel>OTP</InputLabel>
                                <OutlinedInput
                                    type="number"
                                    value={code}
                                    fullWidth
                                    sx={{ textTransform: "none" }}
                                    onChange={(event) => setCode(event.target.value)}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton edge="end" >
                                                <PinOutlinedIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    label="OTP"
                                />
                            </FormControl>
                            <FormControl required fullWidth variant="outlined" size="small" sx={{ textTransform: "none" }}>
                                <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
                                <OutlinedInput
                                    type={showPassword ? 'text' : 'password'}
                                    value={password}
                                    fullWidth
                                    sx={{ textTransform: "none" }}
                                    onChange={(event) => setPassword(event.target.value)}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton onClick={() => setShowPassword(!showPassword)} edge="end" >
                                                {showPassword ? <VisibilityOffOutlinedIcon /> : <VisibilityOutlinedIcon />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    label="Password"
                                />
                            </FormControl>
                            <Button type="submit" disabled={code.trim() === "" || password.trim() === ""} variant="contained" sx={{ textTransform: "none", maxWidth: "50%", marginBottom:"10px" }} startIcon={<SaveAsIcon />} >Change Password</Button>
                        </Box>
                    </form>
                </Card>
            </div>
        </div >
    )
}

export default ForgotPassword